import FORMFIELD from '../../../../../../../DOM/form/fieldset/formfieldgroup/formfield/FORMFIELD.js';
import INPUTTEL from '../../../../../../../DOM/form/fieldset/field/input/inputs/INPUTTEL.js';
import { buttongroupModel, buttongroupAttr } from '../../../../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import { makeStruct } from '../../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../../enums/ModelData.js';
import { labelModel } from '../../../../../../../DOM/form/label/LABEL.js';
import { fieldModel } from '../../../../../../../DOM/form/fieldset/field/FIELD.js';
import { spanModel } from '../../../../../../../DOM/span/SPAN.js';
// Model Structure
export const formInputTelAttr = makeAttrStruct([
    ['class']
]);
export const formInputTelData = makeDataStruct([
    ['label', labelModel()],
    ['field', fieldModel()],
    ['message', spanModel()],
    ['buttons', buttongroupModel(buttongroupAttr('form-field-buttons'))]
]);
export const formInputTelModel = makeStruct([
    ['attributes', formInputTelAttr],
    ['data', formInputTelData]
]);
// Simplified Model
export function formInputTel(label, field, message, className) {
    return {
        attributes: formInputTelAttr(className),
        data: formInputTelData(label, field, message)
    };
}
/** Represents an Input[type=tel] for a Form */
export default class FORMINPUTTEL extends FORMFIELD {
    constructor(node, model) {
        super(node, model);
    }
    createField(model) {
        return new INPUTTEL(this, model);
    }
}
